import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PostingsApi from '../../../API/shipment/postings-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { LinkBlue } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';
import HistoryPostingBlock from './HistoryBlock';
import InfoBlock from './InfoBlock';

function PostingPage() {
  const { search } = useLocation();
  const { number } = useParams()

  // const query = React.useMemo(() => new URLSearchParams(search), [search]);

  const [posting, setPosting] = useState({});
  const [cardsMap, setCardsMap] = useState({});

  const [load, setLoad] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // const number = query.get('number');

    PostingsApi.getPosting({ data: { postingNumber: number } })
      .then((res) => {
        setPosting(res.posting);
        setCardsMap(res.cardsMap);

        setLoad(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 120) {
          setError('Не удалось найти заказ в системе');
        }
      });
  }, [number]);

  return (
    <Content>
      <H1 style={{ marginBottom: 0 }}>
        Заказ {posting.market} {error.length > 0 ? error : posting.posting_number}
      </H1>
      <LinkBlue to={'/shipment/postings'} style={{ marginBottom: '10px' }}>
        Вернуться к заказам
      </LinkBlue>
      <Row style={{ alignItems: 'flex-start', width: '100%' }}>
        {load && <InfoBlock posting={posting} cardsMap={cardsMap} setPosting={setPosting} />}
      </Row>

      <WhiteBlock>
        <Column>
          {load && (
            <HistoryPostingBlock
              history={posting.history?.filter(
                (item) => !['comment', 'comment_checkup', 'checkup_response_links'].includes(item.field),
              )}
            />
          )}
        </Column>
      </WhiteBlock>
    </Content>
  );
}

export default PostingPage;
